<template>
  <div class="spaceCenter common">
    <div>
      <div class="spaceLeft item-box">
        <label>到期日期：</label>
        <span class="text-color-gold" style="margin-right:5px;">{{modalData.exDay | dateFormat("YYYY-mm-dd")}} </span>
      </div>
      <div class="spaceLeft item-box">
        <label>原到期日期：</label>
        <span style="margin-right:5px;">{{modalData.oriExDay | dateFormat("YYYY-mm-dd")}} </span>
      </div>
      <div class="spaceLeft item-box">
        <label>交易密码：</label>
        <a-input type="password" v-model="txnPwd" class="item-input" />
      </div>
      <div class="spaceCenter model-footer-btns">
        <a-button class="btn-big btn-blue-line" @click="modalCancel">返回</a-button>
        <a-button
          class="btn-big"
         
          type="primary"
          @click="modalOk"
          :loading="modalLoad"
          :disabled="!txnPwd"
        >确认</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyTradePassword } from "@/api/gold.js";
import {ReviewExdatechangeApi} from "@/api/review.js"
export default {
  props: ["modalData"],
  name: "exdate-change-password-modal",
  data() {
    return {
      modalLoad: false,
      txnPwd: ""
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    modalOk(e) {
      if (!this.txnPwd || this.txnPwd.length < 6) {
        this.$message.error('请输入有效的交易密码');
        return;
      }
      this.modalLoad = true;
      let params = { tradePassword: this.txnPwd };
      verifyTradePassword(params)
        .then((res) => {
            let p = {
                gldListStr:JSON.stringify(this.modalData.list),
                txnPwd:this.utils.getPasswordEncryptString(this.txnPwd),
                recPersonInfo:JSON.stringify(this.modalData.recPersonInfo)
            };
            this.ReviewBillIssue(this.utils.getPasswordEncryptString(this.txnPwd));
            
        })
        .catch((error) => {
            this.modalLoad = false;
            console.log(error);
        });
    },
    ReviewBillIssue(encrypted){
      const param = {
        txnPwd: encrypted, 
        gldIds: this.modalData.gldIds, 
        status: this.modalData.status
      }
      ReviewExdatechangeApi(param)
      .then(res => {
        this.modalLoad = false;
        this.$message.success(res.description);
        this.$emit("ok",this.utils.getPasswordEncryptString(this.txnPwd));
      })
      .catch(err => {
        this.modalLoad = false;
        console.log(err);
      })
    },
    modalCancel(e) {
      this.modalLoad = false;
      this.$emit("cancel");
    }
  }
};
</script>
<style scoped>
    .item-box > label {
        min-width: 70px;
    }
    .item-box {
        margin: 0 15px 15px 0;
        
    }
    .item-input {
        width: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/review/exdate-change/exdate-change-password-modal.vue